import { CustomerFiles, Roles, Users } from '@prisma/client';
import { User } from '../interfaces';
import { isUserEmployeeOrAdmin } from '../utils/global/helper';
import { BLACKLIST_PHONE_EDIT } from '../constants/customers';
import client from '../utils/react-query/client';
import axios from './api';
import { uploadFiles } from './global';
import { getCustomerFileName } from '../helpers/customers';

export const isCustomerEditDisabled = (
  customerUser: Pick<User | Users, 'role' | 'phoneNumber'>,
) =>
  !!customerUser &&
  (isUserEmployeeOrAdmin(customerUser?.role as Roles) ||
    BLACKLIST_PHONE_EDIT.includes(customerUser?.phoneNumber));

export const invalidateCustomerOverview = async (customerId: string) => {
  await client.invalidateQueries({
    queryKey: ['customer-overview', { customerId }],
    exact: false,
  });
};

export const uploadCustomerFile = async ({
  businessId,
  customerId,
  file,
}: {
  businessId: string;
  customerId: string;
  file: File;
}) => {
  try {
    const path = getCustomerFileName({ businessId, customerId, file });
    const [url] = await uploadFiles([
      {
        id: file.name,
        path,
        url: URL.createObjectURL(file),
      },
    ]);

    const response = await axios.post(`/v1/customers/${customerId}/files`, {
      url,
      businessId,
      customerId,
    });
    return response.data?.result as CustomerFiles;
  } catch (error) {
    throw new Error('Failed to upload file');
  }
};

export const deleteCustomerFile = async ({
  customerId,
  fileId,
}: {
  customerId: string;
  fileId: string;
}) => {
  try {
    const response = await axios.delete(
      `/v1/customers/${customerId}/files/${fileId}`,
    );
    return response.data?.result as boolean;
  } catch (error) {
    throw new Error('Failed to delete file');
  }
};
